import React from 'react';
import { delay, Bowser } from '@factorin/util';

import { getCertsList, EmptyCertificateListError } from 'Modules/business/cryptopro';
import { Button, Label, Text, Icon } from 'Modules/ui2/components';
import info from 'Modules/ui2/icons/info.sprite.svg';
import warning from 'Modules/ui2/icons/warning.sprite.svg';
import { allowedOids, cryptoProLinks, cryptoProPluginDownload } from 'Modules/business/cryptoprofiles';

import styles from '../common.module.scss';


const bowser = new Bowser();

export class NoCertificateComponent extends React.PureComponent {
    state = {
        busy: false,
    };

    updateCertificates = async () => {
        const { updateCertificates } = this.props;
        this.setState({ busy: true });
        if (!await updateCertificates()) {
            // add delay so it doesn't feel instant with broken button
            await delay(1000);
            this.setState({ busy: false });
        }
    };

    render() {
        const { t } = this.props;
        const { busy } = this.state;
        return (
            <>

                <Icon icon={warning} className={styles.errorIcon} size='48' />
                <Label component='h3' weight='demibold' textSize='21-24'>
                    {t('noCertificate.title')}
                </Label>
                <Text component='p' textSize='18'>
                    {t('noCertificate.description')}
                </Text>
                <Button
                    variant='normal'
                    type='button'
                    size='56'
                    className={styles.button}
                    disabled={busy}
                    onClick={this.updateCertificates}
                >
                    {t('noCertificate.refresh')}
                </Button>
            </>
        );
    }
}

const filterCertificates = async cert => {
    const { oid } = await cert.getAlgorithm();
    if (!Object.keys(allowedOids).includes(oid))
        return null;

    const [info, base64] = await Promise.all([
        cert.getOwnerInfo(),
        cert.exportBase64(),
    ]);

    return {
        thumbprint: cert.thumbprint,
        label: cert.label,
        info,
        base64,
    };
};

export class CryptoProImport extends React.PureComponent {
    componentDidMount() {
        this.initCertificates();
    }

    componentDidUpdate() {
        this.initCertificates();
    }

    initCertificates = async () => {
        const { setStage } = this.props;

        if (bowser.mobile || bowser.tablet) {
            setStage('platformNotSuported');
            return;
        }

        try {
            const updateCertificates = async () => {
                try {
                    const allCerts = await getCertsList();
                    const certificates = Array.from(await Promise.all(
                        allCerts.map(filterCertificates),
                    )).filter(data => data != null);

                    if (certificates.length === 0)
                        return false;

                    setStage('formEntry', { certificates });
                    return true;
                } catch (err) {
                    if (err instanceof EmptyCertificateListError)
                        return false;
                    throw err;
                }
            };

            if (!await updateCertificates())
                setStage('noCertificate', { updateCertificates });
        } catch (error) {
            setStage('pluginNotInstalled', {
                link: cryptoProPluginDownload,
                additionalLink: cryptoProLinks[bowser.name],
                details: `${error.message}`,
            });
        }
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <Icon icon={info} className={styles.infoIcon} size='48' />
                <Label component='h3' weight='demibold' textSize='21-24'>
                    {t('allow.title')}
                </Label>
                <Text component='p' className={styles.description} textSize='18'>
                    {t('allow.description')}
                </Text>
            </>
        );
    }
}
